

interface String {
  fix(): Number;
}

interface Number {
  fix(): Number;
  two(): Number;
}

String.prototype.fix = function (): Number {
  const tmp: string = this.toString();
  return Number.isNaN(parseFloat(tmp)) ? 0 : parseFloat(tmp)
};

Number.prototype.fix = function (): Number {
  const tmp: string = this.toString();
  return Number.isNaN(parseFloat(tmp)) ? 0 : parseFloat(tmp)
};

Number.prototype.two = function (): Number {
  const tmp: string = this.toFixed(2);
  return parseFloat(tmp)
};
